module.exports = __webpack_public_path__ + "img/IMG_5526.ff73ac0d.jpg";